import React, { useMemo } from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import { UserRole } from 'generated-graphql/types';
import { TableV2, TableV2Column } from 'components/Table/TableV2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from 'system/atoms';
import { useDrawer } from 'services/drawer/hooks';

const container: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3
};

const headerContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1
};

const buttonSx: SxProps = {
  alignSelf: 'flex-start'
};

type TeamPermission = {
  id: string;
  action: string;
  roles: UserRole[];
};

const teamPermissionsTableData: TeamPermission[] = [
  {
    id: '0',
    action: 'View all campaigns',
    roles: [UserRole.Admin]
  },
  {
    id: '1',
    action: 'Edit own campaigns',
    roles: [UserRole.Admin, UserRole.Member]
  },
  {
    id: '2',
    action: 'Edit question sets',
    roles: [UserRole.Admin]
  },
  {
    id: '3',
    action: 'Takeover all conversations',
    roles: [UserRole.Admin]
  },
  {
    id: '4',
    action: 'View all analysis',
    roles: [UserRole.Admin]
  },
  {
    id: '5',
    action: 'Edit own analysis',
    roles: [UserRole.Admin, UserRole.Member]
  },
  {
    id: '6',
    action: 'Edit rulesets',
    roles: [UserRole.Admin]
  }
];

export const TeamPermissionsDrawer: React.FC = () => {
  const { closeDrawer } = useDrawer();

  const columns: TableV2Column<TeamPermission>[] = useMemo(
    () => [
      {
        name: 'Action',
        selector: (row) => row.action || ''
      },
      {
        name: 'Admin',
        cell: (row) => {
          if (row.roles.includes(UserRole.Admin)) {
            return <CheckCircleIcon />;
          }
        },
        center: true
      },
      {
        name: 'Member',
        cell: (row) => {
          if (row.roles.includes(UserRole.Member)) {
            return <CheckCircleIcon />;
          }
        },
        center: true
      }
    ],
    [teamPermissionsTableData]
  );
  return (
    <Box sx={container}>
      <Box sx={headerContainer}>
        <Typography variant="h3" fontWeight="400">
          Permissions
        </Typography>
        <Typography variant="body2">
          There must be at least one active admin in the account. Add as many of
          the other roles as you need.
        </Typography>
      </Box>
      <TableV2 columns={columns} data={teamPermissionsTableData} />
      <Button sx={buttonSx} variant="primary" onClick={closeDrawer}>
        OK
      </Button>
    </Box>
  );
};
